/** Temporizador de sessão do Office — início + auto-logout configurável. */

export const SESSION_START_KEY = 'aurax_session_started_at';
export const AUTO_LOGOUT_KEY = 'aurax_auto_logout_minutes';

/** Opções em minutos (0 = desativado). */
export const AUTO_LOGOUT_OPTIONS = [
  { minutes: 0, labelKey: 'session.opt.off' },
  { minutes: 30, labelKey: 'session.opt.30m' },
  { minutes: 60, labelKey: 'session.opt.1h' },
  { minutes: 120, labelKey: 'session.opt.2h' },
  { minutes: 180, labelKey: 'session.opt.3h' },
  { minutes: 300, labelKey: 'session.opt.5h' },
  { minutes: 480, labelKey: 'session.opt.8h' },
  { minutes: 720, labelKey: 'session.opt.12h' },
  { minutes: 1440, labelKey: 'session.opt.24h' },
];

const VALID_MINUTES = new Set(AUTO_LOGOUT_OPTIONS.map((o) => o.minutes));

/** Padrão: 8 horas (equilíbrio entre segurança e uso diário). */
export const DEFAULT_AUTO_LOGOUT_MINUTES = 480;

export function readSessionStartedAt() {
  try {
    const raw = localStorage.getItem(SESSION_START_KEY);
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function markSessionStarted({ force = false } = {}) {
  try {
    if (!force && readSessionStartedAt()) return readSessionStartedAt();
    const now = Date.now();
    localStorage.setItem(SESSION_START_KEY, String(now));
    return now;
  } catch {
    return Date.now();
  }
}

export function clearSessionStarted() {
  try {
    localStorage.removeItem(SESSION_START_KEY);
  } catch {
    /* ignore */
  }
}

export function readAutoLogoutMinutes() {
  try {
    const raw = localStorage.getItem(AUTO_LOGOUT_KEY);
    if (raw == null || raw === '') return DEFAULT_AUTO_LOGOUT_MINUTES;
    const n = Number(raw);
    if (!Number.isFinite(n) || !VALID_MINUTES.has(n)) return DEFAULT_AUTO_LOGOUT_MINUTES;
    return n;
  } catch {
    return DEFAULT_AUTO_LOGOUT_MINUTES;
  }
}

export function writeAutoLogoutMinutes(minutes) {
  const n = Number(minutes);
  const value = VALID_MINUTES.has(n) ? n : DEFAULT_AUTO_LOGOUT_MINUTES;
  try {
    localStorage.setItem(AUTO_LOGOUT_KEY, String(value));
  } catch {
    /* ignore */
  }
  return value;
}

export function formatSessionElapsed(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function formatRemaining(ms) {
  const totalSec = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m} min`;
  return `${totalSec}s`;
}
